import React, { useEffect, useState } from 'react';
import './RedactedValue.css';

const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
        <circle cx="12" cy="12" r="3"/>
    </svg>
);

const EyeOffIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
        <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
        <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
);

/**
 * @param {*}       value        the secret
 * @param {string} [placeholder] what is shown while hidden
 * @param {boolean} [reveal]     OPTIONAL nudge from the caller — a "Show all" control on a screen with
 *                               a dozen of these. It is not a takeover: the row's own eye still works
 *                               afterwards, so "show all, then hide the one I am screen-sharing" is
 *                               possible. Callers that do not pass it behave exactly as before.
 */
const RedactedValue = ({ value, placeholder = '••••••••', reveal }) => {
    const [revealed, setRevealed] = useState(!!reveal);

    // FOLLOWS THE CALLER WITHOUT OWNING IT. Syncing on change rather than rendering `reveal` directly is
    // what keeps the per-row toggle meaningful — a fully controlled prop would make the eye do nothing
    // until the parent agreed, which reads as a broken button.
    useEffect(() => {
        if (reveal !== undefined) setRevealed(!!reveal);
    }, [reveal]);

    if (!value) return null;
    return (
        <span className="rv-wrap">
            <span className="rv-value">{revealed ? value : placeholder}</span>
            <button
                type="button"
                className="rv-toggle"
                onClick={() => setRevealed(r => !r)}
                title={revealed ? 'Hide' : 'Reveal'}
            >
                {revealed ? <EyeOffIcon /> : <EyeIcon />}
            </button>
        </span>
    );
};

export default RedactedValue;
